import { useEffect } from 'react';
import {
	useLocation
} from 'react-router-dom';

import { trackPage } from '../adobeAnalytics';
import bgDiscoverPreview from '../assets/images/bg-discover.jpg';
import bgExperiencePreview from '../assets/images/bg-experience.jpg';
import bgExplorePreview from '../assets/images/bg-explore.jpg';
import bgDiscover from '../assets/videos/bg-discover.mp4';
import bgExperience from '../assets/videos/bg-experience.mp4';
import bgExplore from '../assets/videos/bg-explore.mp4';
import FooterNav from '../components/FooterNav';
import { useLocale } from '../Locale';
import AnalyticsContext from './AnalyticsContext';
import I18n from './I18n';
import Link from './Link';


const Landing = (props) => {
	const location = useLocation();
	const locale = useLocale();

	let bgSrc = '';
	let previewSrc = '';
	if (props.pageInfo.name === 'discover') {
		bgSrc = bgDiscover;
		previewSrc = bgDiscoverPreview;
	} else if (props.pageInfo.name === 'experience') {
		bgSrc = bgExperience;
		previewSrc = bgExperiencePreview;
	} else if (props.pageInfo.name === 'explore') {
		bgSrc = bgExplore;
		previewSrc = bgExplorePreview;
	}

	useEffect(() => {
		trackPage(`${locale}|${props.pageInfo.name}`, 'landing');
	}, [locale, props.pageInfo.name]);

	return (
		<AnalyticsContext type="div" className={'container landing fullscreen lang-' + locale + ' ' + props.pageInfo.name} componentName="landing">
			{bgSrc !== '' ? (
				<div className="bg-landing-vid">
					<video width="100%" height="100%" poster={previewSrc} loop autoPlay muted playsInline src={bgSrc} />
				</div>
			) : null}
			<AnalyticsContext type="div" className="content" componentName="content">
				<div className="page-logo lg nissan">NISSAN</div>
				<div className="content-text">
					<h2>
						<I18n t={props.pageInfo.title} />
					</h2>
					<h3>
						<I18n t={props.pageInfo.headline} />
					</h3>
					<p>
						<I18n t={props.pageInfo.text} />
					</p>
					{props.pageInfo.comingSoonText !== '' ? (
						<p>
							<I18n t={props.pageInfo.comingSoonText} />
						</p>
					) : null}
					{/* {props.pageInfo.name === 'experience' && locale === "ar" ? (
						<Link href={I18n.getTranslation(location, 'car.ctaUrl')} className="btn white" text="car.ctaText" />
					)
					:  */}
					<Link href={props.pageInfo.buttonUrl} className="btn white" text={props.pageInfo.buttonText} transition />
					{/* } */}
					<AnalyticsContext type="div" className="landing-bullets" componentName="landingBullets">
						<Link href="experience" className={props.pageInfo.name === 'experience' ? 'active' : ''} transition />
						<Link href="discover" className={props.pageInfo.name === 'discover' ? 'active' : ''} transition />
						<Link href="explore" className={props.pageInfo.name === 'explore' ? 'active' : ''} transition />
					</AnalyticsContext>
				</div>
			</AnalyticsContext>
			<FooterNav
				currentPage={props.pageInfo.name}
				next={{ text: props.pageInfo.nextText, url: props.pageInfo.nextUrl }}
				prev={{ text: props.pageInfo.prevText, url: props.pageInfo.prevUrl }}
			/>
		</AnalyticsContext>
	);
};

export default Landing;
